import React, { useState } from "react";
import { Card, Dialog, DialogContent, Snackbar } from "@mui/material";
import { Container } from "@mui/system";
import Page from "../components/Page";
import MuiAlert from "@mui/material/Alert";
import { HeaderPlaza, PlazaTabla } from "../sections/@catalogos/plazas";
const Plazas = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorGraph, setErrorGraph] = useState({
    severity: "",
    mensaje: "",
  });
  const [bodyDialog, setBodyDialog] = useState("");
  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackBar(false);
  };
  return (
    <>
      <Page title="Administración de Plazas">
        <Container maxWidth="xl">
          <HeaderPlaza
            setOpenDialog={setOpenDialog}
            setBodyDialog={setBodyDialog}
            setErrorGraph={setErrorGraph}
            setOpenSnackBar={setOpenSnackBar}
          />
          <Card>
            <PlazaTabla
              setOpenDialog={setOpenDialog}
              setBodyDialog={setBodyDialog}
              setErrorGraph={setErrorGraph}
              setOpenSnackBar={setOpenSnackBar}
            />
          </Card>
        </Container>
        <Dialog open={openDialog}>
          <DialogContent>{bodyDialog}</DialogContent>
        </Dialog>
        <Snackbar
          open={openSnackBar}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={errorGraph.severity}
            sx={{ width: "100%" }}
          >
            {errorGraph.mensaje}
          </Alert>
        </Snackbar>
      </Page>
    </>
  );
};

export default Plazas;
